var _require = require('lodash'),
    includes = _require.includes;

var winston = require('winston');

var createLogger = winston.createLogger,
    config = winston.config,
    format = winston.format;
var colorize = format.colorize,
    combine = format.combine,
    label = format.label,
    printf = format.printf;
var customFormat = printf(function (info) {
  return "[".concat(info.label, "] ").concat(info.message);
});
var transports = {
  console: new winston.transports.Console({
    level: 'info'
  })
};
var logger = createLogger({
  levels: config.npm.levels,
  format: combine(colorize({
    all: true
  }), label({
    label: 'WeTransfer SDK'
  }), customFormat),
  transports: [transports.console]
});
winston.addColors({
  error: 'red',
  warn: 'yellow',
  info: 'white',
  debug: 'white'
});

function setLoggerLevel() {
  var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'info';

  if (!includes(Object.keys(config.npm.levels), level)) {
    return logger.warn("\"".concat(level, "\" is not a valid logger level. Please specify one of the following levels: [\n      'error',\n      'warning',\n      'info',\n      'verbose,'\n      'debug',\n      'silly'\n    ]"));
  }

  transports.console.level = level;
}

module.exports = logger;
module.exports.setLoggerLevel = setLoggerLevel;